import { render } from "./ProjectEdit.vue?vue&type=template&id=018fc22d"
import script from "./ProjectEdit.vue?vue&type=script&lang=js"
export * from "./ProjectEdit.vue?vue&type=script&lang=js"
script.render = render

export default script